(async function wishlist() {
	const wishlistScript = document.querySelector('[data-cake-wishlist-token]');
	const pageSize = 20;

	if (!wishlistScript) return;

	const delegate = new domDelegate.Delegate(document.body);
	const customer = wishlistScript.dataset.cakeWishlistCustomer;
	const token = wishlistScript.dataset.cakeWishlistToken;
	
	const drawer = document.getElementById('wishlist-drawer');

	// Listen for the wishlist drawer being opened
	const drawerObserver = new MutationObserver(async mutationList => {
		for (const mutation of mutationList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
				if (mutation.target.ariaHidden === 'false') {
					await loadWishlist();
				}
			}
		}
	});
	drawerObserver.observe(drawer, {attributeFilter: ['aria-hidden']});

	const loadWishlist = async () => {
		var main = drawer.querySelector('.Drawer__Main');
		const container = drawer.querySelector('.Drawer__Main .Drawer__Container');

		const loader = document.createElement('div');
		loader.classList.add('BouncingSpinner');
		loader.append(document.createElement('span'));
		loader.append(document.createElement('span'));

		main.classList.add('empty');
		container.replaceChildren(loader);

		const handles = await getWishlist(true);

		const loadProducts = async (page = 0) => {
			document.dispatchEvent(new CustomEvent('theme:loading:start'));
			const pageOffset = page * pageSize;
			// Add 20 (or any other number, really) on the line below so the next page button appears
			const response = await fetch(`${Shopify.routes.root}?section_id=wishlist-products&cache=false&type=${Date.now()}_${Math.random()}&products=${handles.slice(pageOffset, pageOffset + pageSize + 20).join(',')}`);
			const result = new DOMParser().parseFromString(await response.text(), 'text/html');

			result.querySelectorAll('.cake-wishlist-icon').forEach(element => {
				element.addEventListener('click', () => {
					if (element.closest('.Drawer__Container').querySelectorAll('.QuickShopDrawer__Product').length > 1) {
						setTimeout(() => element.closest('.QuickShopDrawer__Product').remove(), 100);
					} else {
						loadProducts('', true);
					}
				});
			});

			if (page == 0) {
				main.replaceWith(result.querySelector('.Drawer__Main'));
				main = drawer.querySelector('.Drawer__Main');
			} else {
				if (!result.querySelector('.Drawer__Main.empty')) {
					// Skip the app promotion
					main.querySelector('.Drawer__Container').append(...result.querySelectorAll('.Drawer__Container > *:not(.Wishlist__AppPromotion)'));
				}
				loader.remove();
			}

			document.querySelectorAll('.cake-wishlist-icon[data-product-handle]').forEach(item => {
				setWishlistButtonState(item.dataset.productHandle, true, main);
			});

			document.dispatchEvent(new CustomEvent('theme:loading:end'));
			document.dispatchEvent(new Event('quickshop:refresh'));
			const button = main.querySelector('button[data-more-products]');
			if (button) {
				if (handles.length > pageOffset) {
					button.addEventListener('click', () => {
						button.replaceWith(loader);
						loadProducts(page + 1);
					});
				} else {
					button.remove();
				}
			}
		}

		loadProducts();
	}

	const sendApiRequest = async (endpoint, body, query = false) => {
		let queryString = '';
		if (query && typeof query === 'object') {
			query = new URLSearchParams(query);
			queryString = query.toString();
			if (queryString.length) {
				queryString = `?${queryString}`;
			}
		}
		const options = {
			method: body ? "POST" : "GET",
			headers: {
				"Content-Type": "application/json",
				"X-Cake-Customer-Wishlist-Token": token || null,
				"X-Wishlist-Customer": customer || null
			},
			mode: "cors",
		};
		if (body) options.body = JSON.stringify(body || null);
		return fetch(`https://lists.disturbia.app/public/api/${endpoint}${queryString}`, options).then(response => response.json());
	}

	const getWishlist = async (ignoreCache = false) => {
		let list = false;
		if (!ignoreCache) list = getLocalCache();
		if (!list && customer) {
			console.log('Fetched wishlist from API');
			list = await sendApiRequest('wishlist', null, { shop: Shopify.shop });
			if (list?.email) setLocalCache(list);
		}
		return list?.items || [];
	}

	const setWishlistButtonState = (productHandle, inWishlist, container = null) => {
		container = container || document;
		container.querySelectorAll(`.cake-wishlist-icon[data-product-handle="${productHandle}"]`).forEach(button => {
			button.classList.toggle('cake-product-in-wishlist', inWishlist);
			button.ariaLabel = inWishlist ? button.dataset.ariaLabelRemove : button.dataset.ariaLabelAdd;
		});
	}

	const getLocalCache = () => {
		try {
			const list = JSON.parse(localStorage.getItem('cake_wishlist') || '{}') || {};
			if (list.timestamp >= Date.now() - (60 * 60 * 1000) && list.email === customer) {
				console.log('Retrieved wishlist from local storage');
				return list;
			} else {
				localStorage.removeItem('cake_wishlist');
			}
		} catch (error) {}
		return false;
	}

	const setLocalCache = list => {
		try {
			list.timestamp = Date.now();
			localStorage.setItem('cake_wishlist', JSON.stringify(list));
		} catch (error) {}
	}

	const updateLocalCache = (productHandle, add = true) => {
		try {
			const list = getLocalCache();
			
			if (list.email !== customer) return;

			if (add) {
				list.items?.unshift(productHandle);
			} else {
				list.items = list?.items?.filter(item => item !== productHandle) || [];
			}

			localStorage.setItem('cake_wishlist', JSON.stringify(list));
		} catch (error) {};
	}

	const addProduct = async (productHandle, collectionHandle = null) => {
		setWishlistButtonState(productHandle, true);
		updateLocalCache(productHandle, true);
		try {
			await sendApiRequest('wishlist/add', {
				shop: Shopify.shop || null,
				product_handle: productHandle || null,
				collection_handle: collectionHandle || null,
			}, { without_items_list: 1 });
		} catch (error) {
			console.log('Wishlist error:', error);
			setWishlistButtonState(productHandle, false);
			updateLocalCache(productHandle, false);
			return false;
		}
		return true;
	}
	
	const removeProduct = async (productHandle, collectionHandle = null) => {
		setWishlistButtonState(productHandle, false);
		updateLocalCache(productHandle, false);
		try {
			await sendApiRequest('wishlist/remove', {
				shop: Shopify.shop || null,
				product_handle: productHandle || null,
				collection_handle: collectionHandle || null,
			}, { without_items_list: 1 });
		} catch (error) {
			console.log('Wishlist error:', error);
			setWishlistButtonState(productHandle, true);
			updateLocalCache(productHandle, true);
			return false;
		}
		return true;
	}

	if (Cookies.get('cake_wishlist_add') && customer) {
		const [product, collection] = Cookies.get('cake_wishlist_add').split(':');
		Cookies.remove('cake_wishlist_add');
		addProduct(product, collection);
	}

	delegate.on('click', '.cake-wishlist-icon', async function(event) { 
		event.preventDefault();

		const productHandle = event.target.dataset.productHandle || event.target.closest('[data-product-handle]').dataset.productHandle;
		const path = window.location.pathname.split('/');
		const collectionIndex = path.indexOf('collections');
		let collectionHandle;
		if (collectionIndex >= 0 && collectionIndex <= 1 && collectionIndex < path.length - 1) {
			collectionHandle = path[collectionIndex + 1];
		}
		
		const target = event.target.matches('.cake-wishlist-icon') ? event.target : event.target.closest('.cake-wishlist-icon');
		if (customer) {
			if (target.classList.contains('cake-product-in-wishlist')) {
				await removeProduct(productHandle, collectionHandle);
			} else {
				await addProduct(productHandle, collectionHandle);
			}
		} else {
			Cookies.set('cake_wishlist_add', `${productHandle}:${collectionHandle}`);
			window.location.replace(target.dataset.loginSrc);
		}
	});

	const items = await getWishlist();
	items?.map(item => setWishlistButtonState(item, true));

	$(document).on('product_list_loaded', async event => {
		const items = await getWishlist();
		items?.map(item => setWishlistButtonState(item, true, event.detail));
	});
})();